<div class="center-on-page">
  <div
    class="mapfre-loader-content d-flex align-items-center flex-column flex-md-row"
    [class.loader-ready]="showContent"
  >
    <div class="order-1 order-md-1">
      <img
        class="b2c-loader-image"
        [src]="stateCode === 'ACMIC' ? 'assets/img/images/Loader-anim-acmic.svg' : 'assets/img/images/Loader-anim.svg'"
        alt="Loader"
      />
    </div>
    <div class="order-2 order-md-2 b2c-text-loader">
      <p [ngClass]="{'b2c-loader-acmic': stateCode === 'ACMIC', 'b2c-loader-MA':stateCode === 'MA'}">We're securely loading your data…</p>
    </div>
  </div>
</div>
